module.exports = __webpack_public_path__ + "static/media/title-hero-2.9eafde0a.jpg";